<template>
  <div>
    <a-dropdown
      v-if="currentUser && currentUser.userName"
      placement="bottomCenter"
      v-model="dropdownVisible"
    >
      <span class="ant-pro-account-avatar">
        <a-avatar
          size="small"
          style="background-color: #0e68cb; margin-top: -4px"
          shape="square"
          >{{ currentUser.accountType === 5 ? "个人" : "企业" }}</a-avatar
        >
        <span class="user-wrapper">
          <span class="user-name">{{ currentUser.userName }}</span>
          <a-icon
            type="down"
            :class="['arrow-icon', { rotate: dropdownVisible }]"
          />
        </span>
      </span>

      <template v-slot:overlay>
        <a-menu class="ant-pro-drop-down menu">
          <a-menu-item key="center" @click="handleToCenter">
            <span style="display: inline-flex; align-items: center">
              <span style="display: inline-flex; align-items: center">
                <a-icon type="user" style="margin-right: 6px" />
                个人中心
              </span>
            </span>
          </a-menu-item>
          <a-menu-divider />
          <a-menu-item-group title="账号切换" v-if="accountList.length !== 0">
            <a-menu-item
              v-for="account in accountList"
              :key="account.accountId"
              class="switch-item"
              :class="{ active: account.accountId === currentUser.accountId }"
              :disabled="account.accountId === currentUser.accountId"
              @click="selectAccount(account)"
            >
              <a-avatar
                size="small"
                shape="square"
                :style="{
                  backgroundColor: '#0060c9',
                }"
              >
                {{ account.accountType === 5 ? "个人" : "企业" }}
              </a-avatar>
              <span class="switch-name" style="margin-left: 4px">
                {{ account.userName }}
              </span>
              <a-icon
                v-if="account.accountId === currentUser.accountId"
                type="check"
                class="check-icon"
              />
            </a-menu-item>
          </a-menu-item-group>

          <a-spin
            size="small"
            v-if="accountList.length === 0"
            style="
              display: flex;
              justify-content: center;
              align-items: center;
              padding: 4px 0;
            "
          />

          <a-menu-divider />
          <a-menu-item key="logout" @click="handleLogout">
            <span style="display: inline-flex; align-items: center">
              <a-icon type="logout" style="margin-right: 7px" />
              登出
            </span>
          </a-menu-item>
        </a-menu>
      </template>
    </a-dropdown>
    <span v-else>
      <a-spin size="small" :style="{ marginLeft: 8, marginRight: 8 }" />
    </span>
    <a-modal
      :width="450"
      :footer="null"
      :visible="switchVisible"
      :closable="false"
      :maskClosable="false"
      :zIndex="999"
      @cancel="closeSwitchMoudle"
      destroyOnClose
    >
      <SwitchAccount :switch-account="switchAccount" @closeSwitchMoudle="closeSwitchMoudle()"></SwitchAccount>
    </a-modal>
  </div>
</template>

<script>

import { Modal } from "ant-design-vue";
import store from "@/store";
import { resetRouter } from "@/router";
import { listSwitchAccount } from "@/api/user/login/Login.js";
import SwitchAccount from "./SwitchAccount.vue";

export default {
  name: "AvatarDropdown",
  components: {
    SwitchAccount,
  },
  props: {
    currentUser: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      accountList: [],
      dropdownVisible: false,
      switchVisible: false,
      switchAccount: {},
    };
  },
  watch: {
    // 当鼠标移到用户名或头像出，触发，箭头向下，展开下拉框
    dropdownVisible(val) {
      if (val) {
        this.handleVisibleChange(); // 展开时刷新账号列表
      }
    },
  },
  methods: {


    handleVisibleChange() {
      this.accountList = [];
      listSwitchAccount()
        .then((res) => {
          if (res.code == "200") {
            this.accountList = res.data;
          } else {
            this.$notification["error"]({
              message: "错误",
              description: res.msg,
            });
          }
        })
        .catch((err) => {
          this.$notification["error"]({
            message: "错误",
            description: "网络异常，请稍后再试",
            duration: 4,
          });
        });
    },
    handleToCenter() {
      this.$router.push({ path: "/personalCenter" });
    },
    handleLogout() {
      //1.重置路由表
      resetRouter();
      //删除store和storage中的信息
      Modal.confirm({
        title: "信息",
        content: "您确定要注销吗？",
        onOk: () => {
          return store.dispatch("Logout").then(() => {
            this.$router.push({ name: "login" });
          });
        },
        onCancel() {},
      });
    },
    selectAccount(account) {
      this.switchAccount = account;
      this.switchVisible = true;
    },
    closeSwitchMoudle() {
      this.switchVisible = false;
    },
  },
};
</script>

<style lang="less" scoped>
.ant-pro-drop-down {
  /deep/ .action {
    margin-right: 8px;
  }
  /deep/ .ant-dropdown-menu-item {
    min-width: 160px;
  }
}
.switch-item {
  display: flex;
  align-items: center;
  padding: 4px 2px; /* ✅ 整体左右留2px */
  box-sizing: border-box;

  .ant-avatar {
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
    font-size: 12px;
    width: 24px;
    height: 24px;
    margin-right: 4px; /* ✅ 头像和文字留一点空隙 */
  }

  .switch-name {
    flex: 1;
    font-size: 13px;
    margin: 0 2px; /* ✅ 名称两边各留2px */
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .check-icon {
    margin: 0 2px; /* ✅ 对勾与右边留2px */
    font-size: 12px;
  }

  &.active {
    font-weight: 600;
  }
}
.arrow-icon {
  margin-left: 4px;
  transition: transform 0.25s ease;
  vertical-align: middle;
}

.arrow-icon.rotate {
  transform: rotate(180deg);
}
.user-wrapper {
  display: inline-flex;
  align-items: center;
  max-width: 250px; /* ← 根据你的右侧布局宽度调整 */
  white-space: nowrap;
  overflow: hidden;
}

.user-name {
  font-size: 14px;
  font-weight: bold;
  font-family: Arial;
  margin-left: 6px;
  display: inline-block;
  max-width: 200px; /* ← 文本允许的最大宽度 */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
